
define('text!modules/reporting/campaigns/contextual/templates/subitem.html',[],function () { return '{{#list}}\n<li class="stack">\n  {{#keys}}\n    <div class="column detail {{format}} {{key}} {{^isName}}text{{/isName}}" {{#isWidthSaved}}style="width: {{columnSubRowsWidth}}px;"{{/isWidthSaved}}>{{value}}</div>\n  {{/keys}}\n</li>\n{{/list}}\n';});

